/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Go_Online_MsgInputs */



/**
* | output |
* | --- |
* | "Upload all offline changes? Players added offline are matched to existing members, or get a new account." |
*
* @param {Offline_Go_Online_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_go_online_msg = /** @type {((inputs?: Offline_Go_Online_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Go_Online_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer toutes les modifications hors ligne ? Les joueurs ajoutés hors ligne sont rapprochés des membres existants, ou reçoivent un nouveau compte.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Subir todos los cambios hechos sin conexión? Los jugadores añadidos sin conexión se asocian a miembros existentes, o reciben una cuenta nueva.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviar todas as mudanças offline? Jogadores adicionados offline são associados a membros existentes, ou recebem uma conta nova.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inviare tutte le modifiche offline? I giocatori aggiunti offline vengono abbinati ai membri esistenti, o ricevono un nuovo account.")
	return /** @type {LocalizedString} */ ("Upload all offline changes? Players added offline are matched to existing members, or get a new account.")
});